
import React from 'react';

interface ProgressBarProps {
  percentage: string;
  color: string;
  direction?: 'left' | 'right';
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, color, direction = 'right' }) => {
  // Convert percentage to a number and ensure it's between 0 and 100
  const parsedPercentage = Math.min(Math.max(parseFloat(percentage) || 0, 0), 100);

  return (
    <div className="relative w-full h-2 bg-gray-100 rounded-full">
      <div 
        className={`absolute h-full ${color} rounded-full transition-all duration-300`}
        style={{ 
          width: `${parsedPercentage}%`,
          [direction === 'left' ? 'right' : 'left']: 0
        }}
      />
    </div>
  );
};
